import React from "react";
import { Link } from "react-router-dom";

import sliderImg1 from "../../assets/img/slider/male1.png";
import shapeImg1 from "../../assets/img/slider/shape-12.png";
import shapeImg2 from "../../assets/img/slider/shape-6.png";
import shapeImg3 from "../../assets/img/slider/shape-14.png";
import shapeImg4 from "../../assets/img/slider/shape-11.png";
import shapeImg5 from "../../assets/img/slider/shape-5.png";
import shapeImg6 from "../../assets/img/slider/shape-13.png";
import shapeImg7 from "../../assets/img/slider/shape-black.png";

const Banner = () => {
  return (
    <div className="slider-2__area grey-bg slider-2__space slider-2__plr p-relative z-index fix">
      <div className="slider-2__shape-1 d-none d-md-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="slider-2__shape-2 d-none d-md-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="slider-2__shape-3 d-none d-xxl-block">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="slider-2__shape-4 d-none d-xxl-block">
        <img src={shapeImg4} alt="" />
      </div>
      <div className="slider-2__shape-5 d-none d-xl-block">
        <img src={shapeImg5} alt="" />
      </div>
      <div className="slider-2__shape-6 d-none d-xl-block">
        <img src={shapeImg6} alt="" />
      </div>
      <div className="slider-2__shape-7">
        <img src={shapeImg7} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6">
            <div className="slider-2__wrapper z-index">
              <div className="slider-2__section-box">
                <h4
                  className="section-subtitle char-anim wow animate__fadeInUp"
                  data-wow-duration=".7s"
                >
                  HELLO, MY NAME IS
                </h4>
                <h3
                  className="hero-title char-anim wow animate__fadeInUp"
                  data-wow-duration=".7s"
                >
                  Ayush <span>Mishra</span>
                </h3>
              </div>
              <div className="slider-2__content">
                <h4
                  className="slider-2__title-sm char-anim wow animate__fadeInUp"
                  data-wow-duration=".9s"
                >
                  Web | Mobile | Desktop App Developer
                </h4>
                <p
                  className="char-anim-2 wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  I create web apps, mobile apps, and desktop apps using React
                  and React Native. From restaurant POS systems and inventory
                  management to CRM software and any business application you
                  need - I build solutions that streamline your business
                  operations and boost efficiency.
                </p>
              </div>
              <div
                className="slider-2__btn wow animate__fadeInUp"
                data-wow-duration="1.1s"
              >
                <Link
                  to="/projects"
                  className="main-btn tp-btn-hover alt-color"
                >
                  <span>View My Projects</span>
                  <b></b>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="slider-2__thumb text-center">
              <img
                src={sliderImg1}
                alt="Ayush Mishra - Web & Mobile App Developer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
